/* eslint-disable @typescript-eslint/no-unused-vars */
import { CountryCode } from "utils/mandators/enums";
import {
  FeatureFlagKey,
  type PartialFeatureFlags,
} from "../utils/resolveFlags/featureFlags.type";

export const featureFlagsCI: PartialFeatureFlags = {
  // WIZARDS
};
